import { useState } from "react";
import { useSearch } from "@tanstack/react-router";
import { z } from "zod";

export enum SettingsWorkflow {
  Subscription = "subscription",
  Password = "password",
  PrivacyPolicy = "privacy-policy",
  TermsAndConditions = "terms-and-conditions",
}
export type SettingsWorkflowType = `${SettingsWorkflow}`;
const searchSchema = z.object({
  tab: z.nativeEnum(SettingsWorkflow).optional(),
});

type HookConfig = {
  isMobile?: boolean;
};

function useSettingsWorkflow({ isMobile = false }: HookConfig) {
  const tab = useSearch({
    strict: false,
    select: (search) => {
      const { data } = searchSchema.safeParse(search);

      return data?.tab;
    },
  });

  const [selectedWorkflow, changeWorkflow] = useState<SettingsWorkflowType>(
    tab ?? SettingsWorkflow.Subscription
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(!!tab);

  function handleDrawerClose() {
    setIsDrawerOpen(false);
  }

  function handleWorkflowChange(workflow: SettingsWorkflowType) {
    changeWorkflow(workflow);
    setIsDrawerOpen(isMobile);
  }

  return {
    isDrawerOpen,
    handleDrawerClose,
    handleWorkflowChange,
    selectedWorkflow,
  };
}

export { useSettingsWorkflow };
